import React from 'react';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { IMPROVED_RATE_INFO_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCREEN } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { PAYMENT_CONFIRMATION } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { DELIVERY_CASH } from 'apps/auth/constants/Constants';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { getDDMMMYYYYDate, getHistoryTransactionDate } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, useLanguage } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

import PreCheckRow from './PreCheckRow';

const PreCheckRate = (props) => {
    let title = '';
    let text = '';

    const { countryId: userCountryId } = useAuth();
    const { lang } = useLanguage();
    const { calculatorFeePopup, fromCountry, commission } = useExtra();
    const exchangePopupTextForPromo = commission?.bonusSpecialRate && fromCountry.promoForPayment?.type ? calculatorFeePopup : null;

    const getTextPopup = () => {
        if (exchangePopupTextForPromo) {
            return <DangerouslyHtml dangerouslyHtml={exchangePopupTextForPromo} />;
        }

        return MarkdownService.splitByParagraph(props.specialBonusRateInfo, [
            userCountryId === USA ? getHistoryTransactionDate(props.rateInfo?.rateChangeTill, lang) : getDDMMMYYYYDate(props.rateInfo?.rateChangeTill, lang),
        ]);
    };

    const popup = (
        <SimplePopup text={getTextPopup()} handleClose={props.closeHandlerForPopup} onPopupClose={props.closeHandlerForPopup}>
            <PopupButton
                iconName="check"
                text={props.gotIt}
                onClick={(e) => {
                    e.preventDefault();
                    props.closeHandlerForPopup();
                }}
            />
        </SimplePopup>
    );

    const onClickHandler = () => {
        if (props.rateInfo?.rateChange && props.specialBonusRateInfo) {
            amplitude.getInstance().logEvent(IMPROVED_RATE_INFO_CLICKED, { [SCREEN]: PAYMENT_CONFIRMATION });
            props.popupRef?.current?.open(popup);
        }
    };

    const renderWithIcon = (rateInfo, text) => {
        return (
            <Text variant="span" size="secondary" color="primary">
                {text}
                <DiskButton
                    type="button"
                    variant="tertiary"
                    iconName={'info-rounded'}
                    iconColor="primary"
                    size="small"
                    marginRight="-8px"
                    marginTop="-4px"
                    raised={false}
                />
            </Text>
        );
    };

    const renderWithoutIcon = (text) => {
        return <>{text}</>;
    };

    title = props.userCountry === USA ? props.precheckUsaAmountFxRate : props.precheckAmountFxRate;
    if (props.exchangeRate) {
        text = props.exchangeRate;
    } else if (props.deliveryMethod === DELIVERY_CASH && props.exchangeRatioText) {
        text = props.exchangeRatioText;
    } else if (props.rateInfo && props.rateInfo.fromCurrency !== props.rateInfo.toCurrency) {
        text = `${props.rateInfo.fromAmount} ${props.rateInfo.fromCurrency} = ${props.rateInfo.toAmount} ${props.rateInfo.toCurrency}`;
    }
    if (title && text) {
        return (
            <PreCheckRow
                title={title}
                text={props.rateInfo?.rateChange ? renderWithIcon(props.rateInfo, text) : renderWithoutIcon(text)}
                textColor="primary"
                onClick={onClickHandler}
            />
        );
    } else {
        return false;
    }
};

export default PreCheckRate;
